export const environment = {
  production: false,
  B2E_clientId: '3ab9eff5-5a2d-4ee3-a01a-31b22baa750d',
  B2E_scope: [
    'openid',
    'profile',
    'api://3ab9eff5-5a2d-4ee3-a01a-31b22baa750d/app_access',
  ],
  redirectURI: 'https://gpd-rzu.ams1907.com',
  apiUrl: 'https://b2c.ams1907.com/gpdwebrdf/',
  fileUploadUrl: 'https://b2c.ams1907.com/gpdwebrdf/gpd-file-upload/',
};
